// extracted by mini-css-extract-plugin
module.exports = {"breakpointXs":"0","breakpointXx":"425px","breakpointSm":"576px","breakpointMd":"768px","breakpointLg":"992px","breakpointXl":"1200px","breakpointXxl":"1700px"};